module.exports = __webpack_public_path__ + "img/close-eye.0b528a06.svg";